import React from 'react'
import { Dispatch } from '../store'
import { useDispatch } from 'react-redux'
import { MOBILE_WIDTH } from '../constants'
import { Box, useMediaQuery, ListItemSecondaryAction } from '@mui/material'
import { ListItemLocation } from './ListItemLocation'
import { LicenseSelect } from './LicenseSelect'
import { RoleSelect } from './RoleSelect'
import { Duration } from './Duration'
import { spacing } from '../styling'
import { Avatar } from './Avatar'

type Props = {
  member: IOrganizationMember
  roles?: IOrganizationRole[]
  disabled?: boolean
  enterprise?: boolean
  link?: boolean
}

export const OrganizationMember: React.FC<Props> = ({ member, roles = [], disabled, enterprise, link = true }) => {
  const hideActions = useMediaQuery(`(max-width:${MOBILE_WIDTH}px)`)
  const dispatch = useDispatch<Dispatch>()
  return (
    <ListItemLocation
      dense
      disabled={!link}
      key={member.user.id}
      to={`/organization/members/${member.user.id}`}
      icon={<Avatar email={member.user.email} size={28} />}
      title={member.user.email}
      subtitle={
        <>
          Added <Duration startDate={member?.created} ago />
        </>
      }
    >
      {hideActions || (
        <ListItemSecondaryAction>
          <RoleSelect
            roles={roles}
            roleId={member.roleId}
            onSelect={(roleId: string) => dispatch.organization.setMembers([{ ...member, roleId }])}
            onClick={event => event.stopPropagation()}
          />
          {!enterprise && (
            <Box width={90} display="inline-block" textAlign="right" marginRight={`${spacing.md}px`}>
              <LicenseSelect member={member} disabled={disabled} />
            </Box>
          )}
        </ListItemSecondaryAction>
      )}
    </ListItemLocation>
  )
}
